import React from 'react';
import styled from 'styled-components';

type Period = 'day' | 'week' | 'month' | 'year' | 'all';

interface PeriodSelectorProps {
  period: Period;
  onChange: (period: Period) => void;
  transparent: boolean;
}

const PeriodOptions = styled.div`
  display: flex;
  align-items: end;
  gap: 12px;
      @media (max-width: 768px) {
    gap: 2px; 
  }
`;

const PeriodOption = styled.button<{ active?: boolean }>`
  background-color: ${({ active }) =>
    active ? 'rgba(246, 246, 246, 1)' : 'var(--primary-color)'};
  color: ${({ active }) =>
    active ? 'var(--primary-color)' : 'rgba(184, 191, 202, 1)'};
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 6px;
  padding: 0 4px;
  width: 36px;
  height: 24px;

  font-family: 'Onest', sans-serif;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: background 0.2s, border-color 0.35s;

  &:hover {
    border-color: white;
  }
    &[data-transparent=true] {
    background-color:  ${({ active }) =>
    active ? 'white' : 'transparent'};
      color: ${({ active }) =>
    active ? 'black' : '#5B5B5B'};
  }
`;

export const PeriodSelector: React.FC<PeriodSelectorProps> = ({ period, onChange, transparent },) => {
  const options: Period[] = ['day', 'week', 'month', 'year', 'all'];

  return (
    <PeriodOptions>
      {options.map((p) => (
        <PeriodOption data-transparent={transparent} key={p} active={period === p} onClick={() => onChange(p)}>
          {p === 'day'
            ? 'D'
            : p === 'week'
            ? 'W'
            : p === 'month'
            ? 'M'
            : p === 'year'
            ? 'Y'
            : 'All'}
        </PeriodOption>
      ))}
    </PeriodOptions>
  );
};
